/**
 * AdminLayout.tsx
 * 
 * 관리자 전용 레이아웃 컴포넌트
 * 
 * 주요 기능:
 * - 관리자 권한 검증 (superAdmin, schoolAdmin)
 * - 관리자 전용 네비게이션 바 표시
 * - 관리자 페이지들의 공통 레이아웃 제공
 * - 권한이 없는 사용자는 홈페이지로 리다이렉트
 * 
 * 사용되는 곳:
 * - 모든 관리자 페이지의 상위 레이아웃
 * - React Router의 Outlet을 통해 하위 컴포넌트 렌더링
 */

import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminNavbar from './AdminNavbar';

/**
 * AdminLayout 컴포넌트
 * 관리자 전용 페이지들의 공통 레이아웃을 제공하는 컴포넌트
 */
const AdminLayout: React.FC = () => {
  // AuthContext에서 현재 로그인한 사용자 정보를 가져옴
  const { currentUser } = useAuth();

  // 권한 검증: 로그인하지 않았거나 관리자가 아닌 경우 홈으로 리다이렉트
  // superAdmin: 최고 관리자 권한
  // schoolAdmin: 학교 관리자 권한
  if (!currentUser || (currentUser.role !== 'superAdmin' && currentUser.role !== 'schoolAdmin')) {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'var(--Color-background-main, #F4F6FA)'
      }}
    >
      <AdminNavbar />

      <main
        style={{
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          padding: '24px 20px',
          paddingTop: '84px',
          boxSizing: 'border-box'
        }}
      >
        <div style={{ width: '100%', maxWidth: '1200px' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout; 